export enum VisitBucketTypeEnum {
  InitialAssessment = 1,
  PatientTasks = 2,
  BaseVisit = 3,
  VisitAddition = 4,
  Wounds = 5,
  Labs = 6,
  Oasis = 7,
  PlanOfCare = 8,
  CompleteOrder = 9,
  Summary = 100
}

export enum VisitBucketTypeSystemNameEnum {
  InitialAssessment = 'initialAssessment',
  PatientTasks = 'patientTasks',
  BaseVisit = 'baseVisit',
  VisitAddition = 'visitAddition',
  Wounds = 'wounds',
  Labs = 'labs',
  Oasis = 'oasis',
  PlanOfCare = 'planOfCare',
  CompleteOrder = 'orderCompletion',
  Summary = 'summary'
}

export const VisitBucketTypeOptions = [
{ id: 1, label: 'Initial Assessment', systemName: 'initialAssessment', order: 1, immediatelyStartBucket: false, hasInitiatingFrequency: false },
{ id: 2, label: 'Patient Tasks', systemName: 'patientTasks', order: 1, immediatelyStartBucket: false, hasInitiatingFrequency: false },
{ id: 3, label: 'Base Visit', systemName: 'baseVisit', order: 2, immediatelyStartBucket: false, hasInitiatingFrequency: true },
{ id: 4, label: 'Visit Addition', systemName: 'visitAddition', order: 2, immediatelyStartBucket: false, hasInitiatingFrequency: true },
{ id: 5, label: 'Wounds', systemName: 'wounds', order: 3, immediatelyStartBucket: false, hasInitiatingFrequency: false },
{ id: 6, label: 'Labs', systemName: 'labs', order: 4, immediatelyStartBucket: false, hasInitiatingFrequency: false },
{ id: 7, label: 'Oasis', systemName: 'oasis', order: 5, immediatelyStartBucket: false, hasInitiatingFrequency: false },
{ id: 8, label: 'Plan of Care', systemName: 'planOfCare', order: 6, immediatelyStartBucket: false, hasInitiatingFrequency: false },
{ id: 9, label: 'Complete Order', systemName: 'orderCompletion', order: 7, immediatelyStartBucket: true, hasInitiatingFrequency: false },
{ id: 100, label: 'Summary', systemName: 'summary', order: 100, immediatelyStartBucket: true, hasInitiatingFrequency: false }
];
